<template lang="">
  <b-modal
    id="file-input-modal"
    ref="fileInputModal"
    class="static-modal"
    :modal-class="{preloading: false, 'hide-send': false }"
    title-class="flex flex-align-center"
    :body-class="{ 'no-bottom-padding': !noFiles }"
    size="xl"
    :lazy="true"
    no-close-on-backdrop
    hide-header-close
    centered
    scrollable
    @hidden="clear">
    <template slot="modal-header" >
      <div>
        <h3>{{ modalTitle }}</h3>
        <div class="subtitle flex flex-align-center">
          <SBIcon
            class="mr-1"
            :icon="SBIconList.INFO"
            :color="SBColors.bluePrimary"
            :size="10" />
          <p class="blue">{{ modalSubtitle }}</p>
        </div>
      </div>
    </template>

    <!-- MODAL BODY -->
    <div
      v-if="(remoteFiles.endpoint && metaData) || !remoteFiles || !remoteFiles.endpoint"
      id="drop-wrapper"
      class="drop-wrapper"
      :class="{ 'no-files': noFiles }"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      @click="dropWrapperClick" >
      <form
        ref="dragForm"
        @submit.prevent="onSubmit">
        <input
          :id="inputId"
          ref="file"
          class="hide"
          :name="inputId"
          type="file"
          multiple
          @change="onChange">
      </form>

      <!-- NO FILES view-->
      <div
        v-if="!fetchingData && noFiles"
        class="base-height flex center-all" >
        <div class="flex column center-all" >
          <SBIcon
            class="mb-1"
            :icon="SBIconList.FILE_UPLOAD"
            :color="SBColors.blackLight"
            :size="16" />
          <p
            v-if="!dropActive"
            class="title mb-1" >Drag & drop files here, or click to select</p>
          <p
            v-if="!dropActive"
            class="subtitle" >Supported types: {{ allowedFileTypes.join(', ') }}</p>
          <!-- PROD-215 Hidden for now -->
          <!-- <a
            v-if="!dropActive"
            href="www.google.com"
            target="_blank"
            @click.stop >View best practices for creating a document</a> -->
          <p
            v-if="dropActive"
            class="title" >
            Drop the files here…
          </p>
        </div>
      </div>

      <!-- FILE list view -->
      <div
        v-else
        class="base-height-margin" >
        <!-- ERROR files -->
        <div
          v-if="errorFiles.length"
          class="file-header flex center-all">
          <p class="ellipsis">Unsupported file types</p>
          <span class="ml-2 mr-3 pill no-shrink">Action required</span>
          <span class="greedy" />
          <div
            class="action flex center-all no-shrink"
            @click="(e) => removeErrorFile(e)" >
            <p class="blue mr-1" >Remove all</p>
            <SBIcon
              class="main-header-icon"
              :icon="SBIconList.TRASH"
              :color="SBColors.bluePrimary"
              :size="14"
              pointer />
          </div>
        </div>
        <div
          v-for="(file, index) in errorFiles"
          :key="`error-${index}`"
          class="flex center-all button-style"
          @click="openFile(file)" >
          <SBIcon
            class="mr-2 no-shrink"
            :icon="SBIconList.X_CIRCLE_FULL"
            :color="SBColors.redPrimary"
            :size="14"
            pointer />
          <p class="greedy ellipsis" >{{ file.name }}</p>
          <SBIcon
            class=""
            :icon="SBIconList.TRASH"
            :color="SBColors.blackUltralight"
            :hover-icon-color="SBColors.blackPrimary"
            :size="14"
            pointer
            @click.native="(e) => removeErrorFile(e, index)" />
        </div>

        <!-- DUPLICATE files -->
        <div
          v-if="duplicateFiles.length"
          class="file-header flex center-all">
          <p class="ellipsis">Duplicated files</p>
          <span class="ml-2 mr-3 pill no-shrink">Action required</span>
          <span class="greedy" />
          <div
            class="action flex center-all no-shrink"
            @click="(e) => removeDuplicateFile(e)" >
            <p class="mr-1" >Remove all</p>
            <SBIcon
              :icon="SBIconList.TRASH"
              :color="SBColors.blackUltralight"
              :size="14"
              pointer />
          </div>
          <div
            class="action flex center-all no-shrink"
            @click="(e) => keepDuplicateFile(e)" >
            <p class="mr-1" >Keep all</p>
            <SBIcon
              :icon="SBIconList.TICK_DOUBLE_CIRCLE"
              :color="SBColors.blackUltralight"
              :size="14"
              pointer />
          </div>
          <div
            class="action flex center-all no-shrink"
            @click="(e) => overrideDuplicateFile(e)" >
            <p class="blue mr-1" >Override all</p>
            <SBIcon
              class="main-header-icon"
              :icon="SBIconList.TICK_CIRCLE"
              :color="SBColors.bluePrimary"
              :size="14"
              pointer />
          </div>
        </div>
        <div
          v-for="(file, index) in duplicateFiles"
          :key="`duplicate-${index}`"
          class="flex center-all button-style"
          @click="openFile(file)" >
          <SBIcon
            class="mr-2 no-shrink"
            :icon="SBIconList.FILE_DOUBLE"
            :color="SBColors.redPrimary"
            :size="14"
            pointer />
          <p class="greedy ellipsis" >{{ file.name }}</p>
          <SBIcon
            class=""
            style="margin-right: 12px;"
            :icon="SBIconList.TRASH"
            :color="SBColors.blackUltralight"
            :hover-icon-color="SBColors.blackPrimary"
            :size="14"
            pointer
            @click.native="(e) => removeDuplicateFile(e, index)" />
          <SBIcon
            class=""
            style="margin-right: 12px;"
            :icon="SBIconList.TICK_DOUBLE_CIRCLE"
            :color="SBColors.blackUltralight"
            :hover-icon-color="SBColors.blackPrimary"
            :size="14"
            pointer
            @click.native="(e) => keepDuplicateFile(e, index)" />
          <SBIcon
            class=""
            :icon="SBIconList.TICK_CIRCLE"
            :color="SBColors.bluePrimary"
            :hover-icon-color="SBColors.blackPrimary"
            :size="14"
            pointer
            @click.native="(e) => overrideDuplicateFile(e, index)" />
        </div>

        <!-- OK files -->
        <div
          v-if="files.length"
          class="file-header flex align-flex-end">
          <div class="flex column greedy">
            <p class="ellipsis greedy flex flex-align-center weight-500">Files
              <DotSeparator
                :size="4"
                class="ml-2 mr-2" />
              <span
                class="file-length weight-500"
                :class="{ red: files.length > maxFiles }" >{{ totalCount | bigDigits }}</span>&nbsp;/ {{ maxFiles | bigDigits }}</p>
            <div
              v-if="files.length && files.length > 10"
              class="greedy flex flex-align-center mt-2" >
              <SBIcon
                class="mr-2"
                :icon="SBIconList.MAGNIFIER"
                :color="SBColors.blackUltralight"
                :size="12" />
              <b-form-input
                ref="searchQueryRef"
                v-model="searchQuery"
                type="text"
                autocomplete="off"
                class="mr-2"
                :class="{'w-100': true }"
                placeholder="Search..."
                @input="inputChange" />
            </div>
          </div>
          <div
            v-if="files.length"
            class="flex flex-align-center"
            style="height: 17px;" >
            <!-- <div
              v-if="filteredFiles.length"
              class="action flex center-all no-shrink"
              @click="(e) => removeFile(e)" >
              <p class="mr-1 no-shrink" >Remove all</p>
              <SBIcon
                class="main-header-icon"
                :icon="SBIconList.TRASH"
                :color="SBColors.blackUltralight"
                :size="14"
                pointer />
            </div> -->
          </div>
        </div>
        <div
          v-if="files.length && !filteredFiles.length"
          class="flex flex-align-center mt-2"
          style="color: #54626c; font-size: 14px; line-height: 1.2;" >
          <span class="emoji-fix no-shrink mr-2">😐</span>
          <p>We could't find anything for <span style="font-weight: 500 !important;">{{ searchQueryAfterDebounce }}</span></p>
        </div>
        <div
          v-for="(file, index) in filteredFiles"
          :id="`file-${file.uid}`"
          :key="`ok-${index}`"
          class="flex center-all button-style"
          :class="{ 'error': file.upload_failed }"
          @click="openFile(file)" >
          <SBIcon
            class="mr-2 no-shrink"
            :icon="file.upload_failed ? SBIconList.TRIANGLE_EXCLAMATION : SBIconList.TICK_FILE"
            :color="file.upload_failed ? SBColors.redPrimary : SBColors.blackPrimary"
            :size="14"
            pointer />
          <p class="ellipsis" >{{ file.name | withoutExtension }}</p>
          <p class="greedy no-shrink mr-2" >{{ file.name | onlyExtension }}</p>
          <SBIcon
            class=""
            :icon="SBIconList.TRASH"
            :color="SBColors.blackUltralight"
            :hover-icon-color="SBColors.blackPrimary"
            :size="14"
            pointer
            @click.native="(e) => removeFile(e, file)" />
          <b-popover
            v-if="file.upload_failed"
            :target="`file-${file.uid}`"
            triggers="hover"
            placement="top"
            custom-class="basic-popover flex-body"
            boundary="viewport" >
            This file could not be processed.
          </b-popover>
        </div>
      </div>
    </div>

    <LoadMoreData
      v-if="remoteFiles && remoteFiles.endpoint && (!linksData || (linksData && linksData.next))"
      class="data-loader mt-3"
      :loading="false"
      @loadMore="fetchData" />

    <!-- Add file button -->
    <div
      v-if="!noFiles"
      class="add-button" >
      <div
        class="show-hand flex center-all"
        @click="addFile" >
        <SBIcon
          class="mr-2"
          :icon="SBIconList.PLUS"
          :color="SBColors.blackPrimary"
          :size="8"/>
        <p>Add file</p>
      </div>
    </div>
    <!-- MODAL BODY end-->

    <template slot="modal-footer">
      <b-button
        :class="{loading: false}"
        :disabled="false"
        @click="hide">
        <span>Cancel</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
      <b-button
        variant="primary"
        :class="{loading: false}"
        :disabled="!edited || !!errorFiles.length || !!duplicateFiles.length || files.length > maxFiles"
        @click="emitData">
        <span>Done</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'debounce';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import randomString from '@/helpers/randomString';
import { getFileExtension } from '@/helpers/mediaHelpers';
import DotSeparator from '@/components/common/DotSeparator';
import ToasterMixin from '@/mixins/Toaster';
import api from '@/helpers/api';
import LoadMoreData from '@/components/common/widgets/LoadMoreData';

export default {
  name: 'FileInputModal',
  components: {
    SBIcon,
    DotSeparator,
    LoadMoreData,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    allowedFileTypes: {
      type: Array,
      required: false,
      default: () => ['pdf', 'jpg', 'jpeg', 'png'],
    },
    maxFiles: {
      type: Number,
      required: false,
      default: 5,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    remoteFiles: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'Add files',
    },
    modalSubtitle: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      edited: false,
      files: [],
      duplicateFiles: [],
      errorFiles: [],
      inputId: '',
      dropActive: false,
      extensions: ['pdf', 'jpg', 'jpeg', 'png'],
      unsupportedFileTypeMessage: 'Unsupported file type.',
      maxFileSize: 16 * 1000000, // 16MB                     // TODO implement
      fileTooBigMessage: 'File is too big.',
      searchQuery: '',
      searchQueryAfterDebounce: '',
      blockNewFiles: false,
      SBColors,
      SBIconList,
      metaData: null,
      linksData: null,
      fetchingData: false,
      noMoreData: false,
      filesToRemove: [],
    };
  },
  computed: {
    ...mapGetters({}),
    noFiles() {
      return this.files.length === 0 && this.duplicateFiles.length === 0 && this.errorFiles.length === 0;
    },
    selectedFilesNames() {
      return this.files.map(file => file.name);
    },
    filteredFiles() {
      return this.files.filter(f => !this.filesToRemove.includes(f.uid)).filter(f => f.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
    },
    totalCount() {
      const newFiles = this.files.filter(f => !f.url);
      return this.count + newFiles.length - this.filesToRemove.length;
    },
  },
  watch: {
    blockNewFiles() {
      if (this.blockNewFiles) {
        this.showToaster('File limit reached.', null, null, 'error');
      }
    },
    files() {
      if (!this.files.length) {
        this.duplicateFiles = [];
        this.errorFiles = [];
      }
    },
    searchQueryAfterDebounce() {
      this.fetchData(true);
    },
  },
  beforeMount() {
    this.inputId = `fileField-${randomString()}`;
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    show(files = [], filesToRemove = []) {
      this.filesToRemove = filesToRemove;
      if (this.filesToRemove.length) {
        this.edited = true;
      }
      this.files = [...files].map(f => new File([f], f.name));
      this.$refs.fileInputModal.show();
      this.loadRemoteFiles(true);
    },
    loadRemoteFiles(first = false) {
      if (this.remoteFiles.endpoint) {
        this.fetchData(first);
      }
    },
    fetchData(searchDataFirstPage = false) {
      if (this.fetchingData) return;
      this.fetchingData = true;
      let endpoint = this.remoteFiles.endpoint;
      const params = {
        noPrefix: true,
      };
      if (!searchDataFirstPage && this.linksData && this.linksData.next) {
        endpoint = this.linksData.next;
      } else if (this.noMoreData) {
        this.fetchingData = false;
        return;
      } else {
        params.page = 1;
        params.limit = 255;
        if (this.searchQuery) {
          params[this.remoteFiles.searchTag] = this.searchQuery;
        }
      }
      api('GET', endpoint, params, null, 'w')
        .then((response) => {
          this.metaData = response.data.meta;
          this.linksData = response.data.links;
          if (searchDataFirstPage) {
            this.files = this.files.filter(f => !f.url); // remove already existing files because those will be replaced by the remote ones passing the search query. Local ones will be filtered in view.
            this.files = [...this.files, ...response.data.data];
          } else {
            this.files = [...this.files, ...response.data.data];
          }

          if (!this.searchQuery && !response.data.links.next) {
            this.noMoreData = true;
          }
        })
        .finally(() => {
          this.fetchingData = false;
        });
    },
    clear() {
      this.$emit('closed');
      this.files = [];
      this.filesToRemove = [];
      this.errorFiles = [];
      this.duplicateFiles = [];
      this.edited = false;
      this.noMoreData = false;
      this.metaData = null;
      this.linksData = null;
      this.searchQuery = '';
    },
    hide() {
      this.files = [];
      this.filesToRemove = [];
      this.$refs.fileInputModal.hide();
    },
    emitData() {
      this.$emit('input', {
        addFiles: this.files.filter(f => !f.url),
        removeFiles: this.filesToRemove,
      });
      this.hide();
    },
    onChange() {
      if (!this.$refs.file.value) {
        return;
      }
      [...this.$refs.file.files].forEach((file) => {
        this.checkMaxFilesReached();
        if (this.blockNewFiles) {
          // return;
        }
        this.proccessFile(file);
      });
      // resets the input field so that the same file can be selected again
      this.$refs.file.value = null;
    },
    dragover(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!e.currentTarget.classList.contains('show-overlay')) {
        e.currentTarget.classList.add('show-overlay');
        this.dropActive = true;
      }
    },
    /** Checks if the target is the child of specified parent. */
    findParentById(element, id) {
      if (element.id === id) {
        return element;
      }
      if (element.parentElement) {
        return this.findParentById(element.parentElement, id);
      }
      return null;
    },
    dragleave(e) {
      e.preventDefault();
      e.stopPropagation();
      // if dragged over the child element of the drop wrapper, do not remove the overlay
      const parentDropWrapper = this.findParentById(e.relatedTarget, 'drop-wrapper');
      if (parentDropWrapper) {
        return;
      }
      e.currentTarget.classList.remove('show-overlay');
      this.dropActive = false;
    },
    removeFile(e, file) {
      e.stopPropagation();
      if (!file.uid) {
        // This is a local file
        const targetFileIndex = this.files.findIndex(f => f.name === file.name);
        if (targetFileIndex >= 0) this.files.splice(targetFileIndex, 1);
      } else {
        const targetFileIndex = this.files.findIndex(f => f.uid === file.uid);
        if (targetFileIndex >= 0) {
          this.filesToRemove.push(this.files[targetFileIndex].uid);
          this.files.splice(targetFileIndex, 1);
        }
      }
      this.edited = true;
    },
    removeErrorFile(e, index = null) {
      // console.log(e);
      e.stopPropagation();
      if (index === null) {
        // console.log('removing all ERROR files');
        this.errorFiles = [];
      } else {
        // console.log('removing ERROR file at index', index);
        this.errorFiles.splice(index, 1);
      }
    },
    /** All the files from duplicates list will get the "_n" suffix and added to the files list.  */
    keepDuplicateFile(e, index = null) {
      e.stopPropagation();
      if (index !== null) {
        this.checkMaxFilesReached();
        if (this.blockNewFiles) {
          // return;
        }
        this.keepDuplicateFileProccessing_parenthesis(this.duplicateFiles[index]);
        this.duplicateFiles.splice(index, 1);
      } else {
        this.duplicateFiles.forEach((file, index) => {
          this.checkMaxFilesReached();
          if (this.blockNewFiles) {
            // return;
          }
          this.keepDuplicateFileProccessing_parenthesis(file);
        });
        this.duplicateFiles = [];
      }
    },
    /**
     * Parses duplicate files and adds them to the files list with the "(n)" suffix.
     * @param {File} file File to be processed
     *
     * TODO : for rewrite you can add a parameter to choose the method of processing
     */
    keepDuplicateFileProccessing_parenthesis(file) {
      const regexTest = new RegExp('(?<full_name>(?<name>.*?)(\\((?<count>\\d*)\\))?)\\.(?<ext>[^.\\n]*)$', '');
      const duplicateName = file.name.match(regexTest);
      const extension = duplicateName.groups.ext ? `.${duplicateName.groups.ext}` : '';
      const extensionRegex = duplicateName.groups.ext ? `\\.${duplicateName.groups.ext}` : '';
      const regexFilter = new RegExp(`${duplicateName.groups.name}( \\(\\d\\))${extensionRegex}`);
      const matchingFiles = this.files.filter(f => regexFilter.test(f.name));
      // Find biggest count of the matching files and add 1
      let highestCount = 0;
      matchingFiles.forEach((f) => {
        let fCount = f.name.match(regexTest).groups.count;
        if (fCount) {
          fCount = parseInt(fCount, 10);
        }
        if (fCount && fCount > highestCount) {
          highestCount = fCount;
        }
      });
      const newCount = parseInt(highestCount, 10) + 1;
      // Now move it to files list
      if (Number.isFinite(newCount)) {
        const newFile = new File([file], `${duplicateName.groups.name} (${newCount})${extension}`);
        this.files.unshift(newFile);
        this.edited = true;
      } else {
        // console.error('newCount is not a number');
      }
    },
    /**
     * Parses duplicate files and adds them to the files list with the "_n" suffix.
     * @param {File} file File to be processed
     */
    keepDuplicateFileProccessing_n(file) {
      const regexTest = new RegExp('(?<full_name>(?<name>.*?)(_(?<count>\\d*))?)\\.(?<ext>[^.\\n]*)$', '');
      const duplicateName = file.name.match(regexTest);
      const extension = duplicateName.groups.ext ? `.${duplicateName.groups.ext}` : '';
      const extensionRegex = duplicateName.groups.ext ? `\\.${duplicateName.groups.ext}` : '';
      const regexFilter = new RegExp(`${duplicateName.groups.name}(_\\d*)?${extensionRegex}`);
      const matchingFiles = this.files.filter(f => regexFilter.test(f.name));
      // Find biggest count of the matching files and add 1
      let highestCount = 1;
      matchingFiles.forEach((f) => {
        let fCount = f.name.match(regexTest).groups.count;
        if (fCount) {
          fCount = parseInt(fCount, 10);
        }
        if (fCount && fCount > highestCount) {
          highestCount = fCount;
        }
      });
      const newCount = parseInt(highestCount, 10) + 1;
      // Now move it to files list
      if (Number.isFinite(newCount)) {
        const newFile = new File([file], `${duplicateName.groups.name}_${newCount}${extension}`);
        this.files.unshift(newFile);
        this.edited = true;
      } else {
        // console.error('newCount is not a number');
      }
    },
    overrideDuplicateFile(e, index = null) {
      e.stopPropagation();
      if (index !== null) {
        this.overrideDuplicateFileProccessing(this.duplicateFiles[index]);
        this.duplicateFiles.splice(index, 1);
      } else {
        this.duplicateFiles.forEach((file) => {
          this.overrideDuplicateFileProccessing(file);
        });
        this.duplicateFiles = [];
      }
    },
    overrideDuplicateFileProccessing(file) {
      const index = this.files.findIndex(f => f.name === file.name);
      if (index !== -1) {
        this.files.splice(index, 1, file);
      } else {
        this.files.unshift(file);
      }
      this.edited = true;
    },
    removeDuplicateFile(e, index = null) {
      e.stopPropagation();
      if (index === null) {
        this.duplicateFiles = [];
      } else {
        this.duplicateFiles.splice(index, 1);
      }
    },
    /**
     * Checks if the file is on the list of acceptable allowedFileTypes.
     * If no extension is set the all files are acceptable.
     *
     * TODO - enable a list of files to be passed and checked
     */
    acceptableFileType(file) {
      const fileToCheck = file;
      const isFileAcceptable = this.allowedFileTypes
        ? this.allowedFileTypes.includes(getFileExtension(fileToCheck.name))
        : true;
      if (isFileAcceptable) {
        this.unsupportedFileType = false;
        this.$emit('error', false);
      } else {
        this.unsupportedFileType = true;
        this.$emit('error', true);
      }
      return isFileAcceptable;
    },
    /** Enables the click on drop wrapper only if there are no files at the moment. */
    dropWrapperClick() {
      if (this.noFiles) {
        this.$refs.file.click();
      }
    },
    addFile() {
      this.$refs.file.click();
    },
    drop(e) {
      e.preventDefault();
      e.stopPropagation();
      [...e.dataTransfer.files].forEach((file) => {
        this.checkMaxFilesReached();
        if (this.blockNewFiles) {
          // return;
        }
        this.proccessFile(file);
      });
      // this.onChange();
      e.currentTarget.classList.remove('show-overlay');

      this.dropActive = false;
    },
    proccessFile(file) {
      if (this.noMoreData && this.selectedFilesNames.includes(file.name)) {
        this.duplicateFiles.push(file);
      } else if (!this.acceptableFileType(file)) {
        this.errorFiles.push(file);
      } else if (this.remoteFiles.endpoint) {
        // check the remote files too before it is added to the list
        this.checkSingleFile(file.name)
          .then(() => {
            this.files.unshift(file);
          })
          .catch(() => {
            this.duplicateFiles.push(file);
          });
        this.edited = true;
      } else { // covers the situation when we do not need the remote validation. e.g. for the empty schema where we create the fresh assistant and we do not need to check the remote files.
        this.files.unshift(file);
        this.edited = true;
      }
    },
    inputChange() {
      this.searchFiles();
    },
    checkSingleFile(fileName) {
      return new Promise((resolve, reject) => {
        const endpoint = this.remoteFiles.endpoint;
        const params = {
          noPrefix: true,
          limit: 1,
          page: 1,
        };
        params[this.remoteFiles.searchTag] = fileName;
        api('GET', endpoint, params, null, 'w')
          .then((response) => {
            if (response.data.data.length === 1) {
              reject();
            } else {
              resolve();
            }
          })
          .finally(() => {
            reject();
          });
      });
    },
    markDebounce() {
      // this.debounceActive = true;
      // this.searchContacts();
    },
    searchFiles: debounce(function f() {
      // console.log('SEARCHING', this.searchQuery);
      // this.debounceActive = false;
      this.searchQueryAfterDebounce = this.searchQuery;
      // this.initialContactsLoaded = false;
      // this.contactsAppended = [];
      // this.clearSelection();
      // this.page = 1;
      // this.loadContacts();
    }, 500),
    checkMaxFilesReached() {
      if (this.files.length === this.maxFiles) {
        // console.log('MAX FILES REACHED');
        this.blockNewFiles = true;
        return;
      }
      this.blockNewFiles = false;
    },
    openFile(file) {
      // In case the file is already available on the backend.
      if (file.url) {
        window.open(file.url, '_blank').focus();
        return;
      }

      // Otherwise, load a local file.
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileURL = event.target.result;

        function base64ToArrayBuffer(_base64Str) {
          const binaryString = window.atob(_base64Str);
          const binaryLen = binaryString.length;
          const bytes = new Uint8Array(binaryLen);
          for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          return bytes;
        }

        const b64 = fileURL.toString().replace(/^data:(.*,)?/, '');
        const byte = base64ToArrayBuffer(b64);
        const contentType = fileURL.toString().match(/data:(.*)?;/, '');
        const blob = new Blob([byte], { type: contentType[1] });
        window.open(URL.createObjectURL(blob), '_blank').focus();
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  margin-top: 3px !important;
  font-size: 12px !important;
  font-weight: normal !important;
  text-align: left !important;
  color: $blackUltralight !important;
}

::v-deep .modal {
  .modal-content {
    border-radius: 10px !important;
  }

  .modal-header {
    padding: 18px 15px !important;
    h3 {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.2;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: $blackUltralight;
    }
  }

  .modal-body {
    // padding: 18px 15px !important;
    padding: 0 !important;
    min-height: 200px;

    // &.no-bottom-padding {
    //   padding-bottom: 0 !important;
    // }

    .data-loader:first-child {
      margin-top: 90px !important;
    }

    .drop-wrapper {
      padding: 18px 15px 0 !important;

      &.no-files {
        // margin: -18px -15px;
        cursor: pointer;
      }

      .title {
        font-size: 14px;
        line-height: 1.2;
        color: $blackLight;
      }

      .subtitle {
        line-height: 1.4 !important;
        text-align: unset !important;
      }

      a {
        margin-top: 25px;
        font-size: 12px;
        line-height: 1.4;
      }

      input, input:focus {
        height: 21px !important;
        padding: 0 !important;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }

      .base-height {
        min-height: 212px;
      }
      .base-height-margin {
        min-height: 142px;
      }

      .main-header-icon {
        margin-right: 13px;
      }

      .file-header, .action-header {
        margin-top: 18px;
        &:first-of-type {
          margin-top: 0;
        }

        .file-length {
          color: $blackUltralight;
        }

        .action {
          color: $blackUltralight;
          cursor: pointer;
          &:not(:last-of-type) {
            margin-right: 12px;
          }

          &:hover {
            * {
              color: $blackPrimary;
            }
            .sb-icon .icon.mask {
              background-color: $blackPrimary !important;
            }
          }
        }

        p {
          font-size: 14px;
          font-weight: 500;

          &.blue {
            color: $bluePrimary;
          }
        }

        span {

        }

        .pill {
          display: flex;
          align-items: center;
          height: 16px;
          padding: 0 8px 0 7px;
          border-radius: 17px;
          background-color: #ffe6e7;
          font-size: 11px;
          font-weight: 500;
          color: $redPrimary;
          // margin-bottom: 1px;
        }
      }

      .button-style {
        max-height: 34px;
        margin: 8px 0;
        padding: 9px 12px;
        border-radius: 10px;
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
        border: solid 1px $greyBorder;
        background-color: $white;
        cursor: pointer;

        // NOTE: This is a workaround for the last button in the list by class
        &:nth-last-child(1 of .button-style) {
          margin-bottom: 3px !important;
        }

        &:hover {
          box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
        }

        p {
          font-size: 14px;
        }

        &.error * {
          color: $redPrimary;
        }
      }

      // div:last-of-type {
      //   &.button-style {
      //     margin-bottom: 80px;
      //   }
      // }
    }

    .add-button {
      position: sticky;
      bottom: 0px;
      background: $greyUltralight;
      // margin: 0 -15px;
      padding: 18px 15px;

      * {
        font-size: 14px;
        font-weight: 500;
        color: $blackPrimary;
      }

      > div {
        min-height: 34px;
        padding: 9px 12px;
        border-radius: 10px;
        background: $greyBorderSecondary;
        // cursor: pointer;
        &:hover {
          background-color: #DDE6E9;
        }
      }
    }
  }

  .modal-footer {
    button {
      border-radius: 10px;

      &.btn-secondary {
        border: solid 1px $greyBorder;
      }
    }
  }
}
</style>
